import React from 'react';
import { useQueryClient } from 'react-query';
import { PAGES, ReactQueryKeys } from 'common/enums';
import useCheckDriversCars from '../../configuration-from-pdf/hooks/use-check-drivers-cars';
import { useLocation } from 'react-router-dom';
import { useTypedSelector } from '../../../hooks/use-typed-selector';
import { User } from '../../../common/interfaces';

const useSelectDriver = (
  openNewConfigurationDialog: () => void,
  openDriverDialog: () => void,
  refreshList: () => void
) => {
  const queryClient = useQueryClient();
  const location = useLocation();
  const user = useTypedSelector<User>(state => state['app'].user);

  const isDriverConfigurationsPage =
    location.pathname.includes(PAGES.CONFIGURATIONS) && !location.pathname.includes(PAGES.NEW_CONFIGURATIONS);

  const { checkDriversCars } = useCheckDriversCars(refreshList);

  const startCreatingPdfConfigurationProcess = () => {
    queryClient.resetQueries([ReactQueryKeys.GetDriversPersonalConfigurations]);
    if (isDriverConfigurationsPage) {
      checkDriversCars({ driverId: user.id, successCallback: openNewConfigurationDialog });
    } else {
      openNewConfigurationDialog();
    }
  };

  const startCreatingConfigurationProcess = () => {
    queryClient.resetQueries([ReactQueryKeys.GetDriversPersonalConfigurations]);
    if (isDriverConfigurationsPage) {
      checkDriversCars({ driverId: user.id, successCallback: openDriverDialog });
    } else {
      openDriverDialog();
    }
  };

  return { startCreatingPdfConfigurationProcess, startCreatingConfigurationProcess };
};

export default useSelectDriver;
